import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  // datas
  availabilities: [],
  month: moment().format('YYYY-MM'),
  endDate: moment().endOf('month').toDate(),
  startDate: moment().toDate()
};

const slice = createSlice({
  name: 'availabilities',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    setDatePicker(state, action) {
      const date = action.payload;
      const today = moment().format('YYYY-MM');
      const dateUpdate = moment(date).format('YYYY-MM');
      state.month = date;
      if (today === dateUpdate) {
        state.startDate = moment().toDate();
        state.endDate = moment().endOf('month').toDate();
      } else {
        state.startDate = date;
        state.endDate = moment(date).endOf('month').toDate();
      }
    },

    getAvailabilities(state, action) {
      const { availabilities, month } = action.payload;
      state.isLoading = false;
      state.availabilities = availabilities;
      const filteredResult = availabilities.filter((el) => el.datetime_end.slice(0, 7) === month);
      state.filteredAvailabilities = filteredResult;
    },

    deleteAvailability(state, action) {
      const { id, month } = action.payload;
      const filteredResult = state.availabilities.filter((el) => el.id !== id);
      state.availabilities = filteredResult;
      const filteredList = filteredResult.filter((el) => el.datetime_end.slice(0, 7) === month);
      state.filteredAvailabilities = filteredList;
    },

    postAvailabilities(state, action) {
      const { form, id } = action.payload;
      const newAvailability = { id, ...form };
      const isCurrentMonth = moment().isSame(moment(newAvailability.datetime_start), 'month');
      if (isCurrentMonth) {
        state.availabilities = [...state.availabilities, newAvailability];
      }
      state.isLoading = false;
    },

    setDates(state, action) {
      const { start, end } = action.payload;

      if (start > end) {
        state.startDate = start;
        state.endDate = start;
      } else {
        state.startDate = start;
        state.endDate = end;
      }
    }
  }
});

// Reducer
export default slice.reducer;
export const { setDatePicker, setDates } = slice.actions;

export function getAvailabilities({ contractIds, date, month }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/availabilities', { contractIds, date, month });
      dispatch(slice.actions.getAvailabilities(result, month));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postAvailabilities({ form, month }, callback) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const result = await socket.post('/availabilities', form);
      if (result.success) {
        callback(result.message);
        dispatch(slice.actions.postAvailabilities({ form, id: result.id, month }));
      }
    } catch (error) {
      callback("Une erreur est survenue lors de l'envoi de votre disponibilité");
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteAvailability({ contractId, id, dateStart, dateEnd, month }, callback) {
  return async (dispatch) => {
    try {
      const result = await socket.delete('/availabilities', { contractId, id, dateStart, dateEnd });
      if (result.success && !result.warning) {
        dispatch(slice.actions.deleteAvailability({ id, month }));
      }
      callback(result.message, result.warning);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
